import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import basic_4003320865, { _demoInfo as basic_4003320865_demoInfo } from "../../../../../packages/console-bar-chart/demo/Basic.tsx?loadDemo";
import horizontal_4003320865, { _demoInfo as horizontal_4003320865_demoInfo } from "../../../../../packages/console-bar-chart/demo/Horizontal.tsx?loadDemo";
import stack_4003320865, { _demoInfo as stack_4003320865_demoInfo } from "../../../../../packages/console-bar-chart/demo/Stack.tsx?loadDemo";
import facet_4003320865, { _demoInfo as facet_4003320865_demoInfo } from "../../../../../packages/console-bar-chart/demo/Facet.tsx?loadDemo";
import dodgeStack_4003320865, { _demoInfo as dodgeStack_4003320865_demoInfo } from "../../../../../packages/console-bar-chart/demo/DodgeStack.tsx?loadDemo";
import color_4003320865, { _demoInfo as color_4003320865_demoInfo } from "../../../../../packages/console-bar-chart/demo/Color.tsx?loadDemo";
import React from 'react';
export default {
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  basic_4003320865,
  basic_4003320865_demoInfo,
  horizontal_4003320865,
  horizontal_4003320865_demoInfo,
  stack_4003320865,
  stack_4003320865_demoInfo,
  facet_4003320865,
  facet_4003320865_demoInfo,
  dodgeStack_4003320865,
  dodgeStack_4003320865_demoInfo,
  color_4003320865,
  color_4003320865_demoInfo,
  React
};